import { BaseService } from './base-service';
import type { NioshReport } from '@/types/Niosh';
import type {
	GetNioshCountHigherRiskFoundParamsDTO,
	GetNioshCountHigherRiskFoundDTO,
	GetNioshReportResponseDTO,
	GetNioshReportRequestDTO
} from '@/core/dto/niosh';
import { NioshReportMapper } from '@/core/mappers/niosh-report';

export class NioshReportService extends BaseService<any> {
	private static instance: NioshReportService;

	private constructor(public readonly basePath: string = '/ergonomic-tool/niosh') {
		super();
	}

	public static getInstance(): NioshReportService {
		if (!NioshReportService.instance) {
			NioshReportService.instance = new NioshReportService();
		}
		return NioshReportService.instance;
	}

	public async getCountHigherRiskFound(
		params: GetNioshCountHigherRiskFoundParamsDTO
	): Promise<GetNioshCountHigherRiskFoundDTO[]> {
		const url = this.basePath + `/risk/count`;
		const { data } = await this.getInstance().get<GetNioshCountHigherRiskFoundDTO[]>(url, { params });
		return data;
	}

	public async getNioshReport(params: GetNioshReportRequestDTO): Promise<NioshReport> {
		const url = this.basePath + `/${params.file_id}`;
		const { data } = await this.getInstance().get<GetNioshReportResponseDTO>(url, { params });
		return new NioshReportMapper(data).toDomain();
	}
}
